export const talent = [
  {
    ascension: 2,
    book: {
      rarity: 2,
      amount: 3,
    },
    commonMaterial: {
      rarity: 1,
      amount: 6,
    },
    bossMaterial: 0,
    eventMaterial: 0,
    mora: 12500,
  },
  {
    ascension: 3,
    book: {
      rarity: 3,
      amount: 2,
    },
    commonMaterial: {
      rarity: 2,
      amount: 3,
    },
    bossMaterial: 0,
    eventMaterial: 0,
    mora: 17500,
  },
  {
    ascension: 3,
    book: {
      rarity: 3,
      amount: 4,
    },
    commonMaterial: {
      rarity: 2,
      amount: 4,
    },
    bossMaterial: 0,
    eventMaterial: 0,
    mora: 25000,
  },
  {
    ascension: 4,
    book: {
      rarity: 3,
      amount: 6,
    },
    commonMaterial: {
      rarity: 2,
      amount: 6,
    },
    bossMaterial: 0,
    eventMaterial: 0,
    mora: 30000,
  },
  {
    ascension: 4,
    book: {
      rarity: 3,
      amount: 9,
    },
    commonMaterial: {
      rarity: 2,
      amount: 9,
    },
    bossMaterial: 0,
    eventMaterial: 0,
    mora: 37500,
  },
  {
    ascension: 5,
    book: {
      rarity: 4,
      amount: 4,
    },
    commonMaterial: {
      rarity: 3,
      amount: 4,
    },
    bossMaterial: 1,
    eventMaterial: 0,
    mora: 120000,
  },
  {
    ascension: 5,
    book: {
      rarity: 4,
      amount: 6,
    },
    commonMaterial: {
      rarity: 3,
      amount: 6,
    },
    bossMaterial: 1,
    eventMaterial: 0,
    mora: 260000,
  },
  {
    ascension: 6,
    book: {
      rarity: 4,
      amount: 12,
    },
    commonMaterial: {
      rarity: 3,
      amount: 9,
    },
    bossMaterial: 2,
    eventMaterial: 0,
    mora: 450000,
  },
  {
    ascension: 6,
    book: {
      rarity: 4,
      amount: 16,
    },
    commonMaterial: {
      rarity: 3,
      amount: 12,
    },
    bossMaterial: 2,
    eventMaterial: 1,
    mora: 700000,
  },
];
